import styled from "styled-components";

export const ProceedWrapper = styled.div`
    display: flex;
    align-items: center;
    position: relative;
  
    .update-wallet-btn{
        height: 30px;
    padding: 0 10px;
    background-color: #00BAF2;
    border: none;
    border-radius: 15px;
    color: #fff;
    }
    &.processButton{
       button{
        background-color: #00286F;
    color: #FFFFFF;
    height: 30px;
    font-size: 13px;
    font-weight: bold;
    font-family: "Cabin", sans-serif;
    border: none;
    border-radius: 5px;
    &:disabled{
        background-color:gray;
    }
       }

    }
    img {
        max-width: 20px;
        height: auto;
        position: absolute;
        left: 110px;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    .primary-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    &.small{
        padding: 4px;
     .primary-btn{
        height: 24px;
     }
    }
`

 export const BulkUploadWrapper = styled.div`
  display: flex;
  gap: 30px;
 
 .left{
  flex: 1 1 30%;
  max-width: 320px;

 
  .card{
    position: relative;
    display: flex;
    justify-content: space-between;
   gap: 20px;
   padding: 10px;
  margin-bottom: 10px;
   width: 100%;
    box-shadow: 0px 2px 3px rgba(0, 41, 112, 0.0509803922);
    border: 1px solid rgba(0, 41, 112, 0.1411764706);
    border-radius: 10px;
    background: #FFFFFF;
   span{
    color: #000;
   }
   &:last-child{
    margin-bottom: 0;
   }
   &.active{
    background-color: #00286F;
    h4,p,span{
        color: #fff;
    }
   }
   /* &::after{
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    left: 0;
    top: calc(100% + 4px);
    height: .5px;
    background-color: #333;
   }
   &:last-child{
    &::after{
     height: 0;
    } */
 }
 &:first-child{
    margin-top: 0;
 }

 h4{
    font-size: 16px;
    margin-bottom: 8px;
    cursor: default;
 }
 p{
    margin-bottom: 4px;
    font-size: 13px;
    cursor: default;
 }
  }

  .button{
    align-self: center;
    background-color: #00BAF2;
    color: rgb(255, 255, 255);
    display: inline-block;
    padding-left: 8px;
    padding-right: 8px;
    text-align: center;
    line-height: 20px;
    font-size: 10px;
    border-radius: 20px;
    position: absolute;
    right: 10px;
    top: 13px;
    span{
        color: #fff;
    }
  }
 
 
 
 .right{
    flex: 1 1 70%;
    box-shadow: 0px 2px 3px rgba(0, 41, 112, 0.0509803922);
    border: 1px solid rgba(0, 41, 112, 0.1411764706);
    border-radius: 10px;
    background: #FFFFFF;

    .header{
        display: flex;
        justify-content: space-between;
        padding: 10px 20px;


        h3{
            font-size: 24px;
            margin-bottom: 10px;
        }
        p{
            font-size: 12px;
        }
        .download{
            display: flex;
            flex-direction: column;
            gap: 8px;
            align-self: center;
            &> div{
                margin-left: auto;
               
               
            }
            .search{
                    padding: 0;
                    input{
                        color: #000;
                    }
                }
        }
    }
   .record{
    padding: 10px 20px 20px;
    table{
        width: 100%;
        border: none;
        font-size: 12px;
        border-spacing: 0;
        thead{
            background-color: #f3f3f9;
            box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
           th{
            padding: 10px 8px ;
            text-align: start;
            
           }
        }

        tbody{
           td{ 
            padding: 10px 8px ;
            text-align: start;

            &.plusIcon{
            span{
                display: inline-block;
                cursor: pointer;
            }
                img{
                    width: 12px;
                }
            }
           }
           tr{
            &:nth-child(even){
                background-color: #f3f3f9;
            }
           }

        }
    }
   }
 }
`;

export const ModalWrapperContant = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
 .modal-content{
    background-color: #fff;
    max-width: 800px;

    .form  >div > div{
   margin-bottom: 20px;
   &.floating-label-input .form-control{
    border-radius: 10px!important;
   }
    }
 }

`;